export default "__VITE_ASSET__BQXMHlpb__"